import { defineNuxtPlugin } from "#app";
import posthog from "posthog-js";

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig();
  const posthogPublicKey = runtimeConfig.public.posthogPublicKey;
  const posthogApiHost = runtimeConfig.public.posthogHost;
  const environment = runtimeConfig.public.environment;
  const posthogEnabled = runtimeConfig.public.posthogEnabled;

  if (!posthogEnabled) {
    return;
  }

  const posthogClient = posthog.init(posthogPublicKey, {
    api_host: posthogApiHost,
    persistence: useCookieManagement().isCookieConsentGiven()
      ? "localStorage+cookie"
      : "memory",
    person_profiles: "identified_only",
    capture_pageview: false,
    debug: environment.toLowerCase() === "development",
    loaded: () => {
      usePosthog().identifyIfNecessary();
    },
  });

  // Make sure that pageviews are captured with each route change
  const router = useRouter();
  router.afterEach((to) => {
    nextTick(() => {
      posthog.capture("$pageview", {
        current_url: to.fullPath,
      });
    });
  });

  return {
    provide: {
      posthog: () => posthogClient,
    },
  };
});
